import {
  SankeyChart,
  Flex,
  ChartSkeleton,
  formatCurrency
} from '@blockanalitica/ui';
import { useApi } from '@/api';
import { getTokenColor } from '@/utils/colors';

interface Flow {
  from: string;
  to: string;
  flow: string;
}

function transformToSankeyData(flows: Flow[]) {
  return {
    datasets: [
      {
        label: '',
        data: flows.map((item) => ({
          from: item.from,
          // hack for showing the flow from WETH -> WETH otherwise the flow doesn't exist
          to: item.to === item.from ? item.from + ' ' : item.to,
          flow: Number(item.flow)
        })),
        colorMode: 'gradient' as 'gradient',
        colorFrom: (ctx: { dataIndex: number }) =>
          getTokenColor(flows[ctx.dataIndex].from),
        colorTo: (ctx: { dataIndex: number }) =>
          getTokenColor(flows[ctx.dataIndex].to),
        color: 'white'
      }
    ]
  };
}
export default function CollateralAssetSankeyChart({
  marketAddress
}: {
  marketAddress: string;
}) {
  const [data, error] = useApi<Flow[]>({
    url: `/markets/${marketAddress}/collateral/sankey/`
  });

  if (error) {
    throw error;
  }

  if (!data || data.length === 0) {
    return (
      <Flex flexDirection="column" gap="xs">
        <ChartSkeleton />
      </Flex>
    );
  }

  const sankeyData = transformToSankeyData(data);

  const config = {
    options: {
      interaction: {
        mode: 'nearest',
        intersect: false
      },
      aspectRatio: 3,
      plugins: {
        tooltip: {
          displayColors: false,
          callbacks: {
            label: (context: { dataIndex: number }) => {
              const flow = data[context.dataIndex];
              return `${flow.from} -> ${flow.to}: ${formatCurrency(Number(flow.flow))}`;
            }
          }
        }
      }
    }
  };

  return <SankeyChart data={sankeyData} config={config} />;
}
